import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Newspaper, Users, MessageSquare, User, Building2 } from "lucide-react";

/**
 * Sticky bottom action bar for mobile only (hidden on md+).
 * Shows core social flows one tap away.
 * - Guest: Feed / Forums / Agencies / Log in
 * - Authed: Feed / Forums / DMs / Profile
 */
export default function MobileTabBar() {
  const { user } = useAuth();
  const authed = user && typeof user === "object";

  const tabs = authed
    ? [
        { to: "/feed", label: "Feed", icon: Newspaper, testid: "tab-feed" },
        { to: "/forums", label: "Forums", icon: Users, testid: "tab-forums" },
        { to: "/messages", label: "DMs", icon: MessageSquare, testid: "tab-dms" },
        { to: `/nurses/${user.id}`, label: "Me", icon: User, testid: "tab-profile" },
      ]
    : [
        { to: "/feed", label: "Feed", icon: Newspaper, testid: "tab-feed" },
        { to: "/forums", label: "Forums", icon: Users, testid: "tab-forums" },
        { to: "/agencies", label: "Agencies", icon: Building2, testid: "tab-agencies" },
        { to: "/login", label: "Log in", icon: User, testid: "tab-login" },
      ];

  return (
    <>
      {/* Spacer so page content isn't hidden behind the fixed bar */}
      <div aria-hidden className="md:hidden h-16" />
      <nav
        data-testid="mobile-tab-bar"
        aria-label="Primary mobile navigation"
        className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[hsl(var(--nh-bg))] border-t-2 border-black grid grid-cols-4 shadow-[0_-4px_0_rgba(0,0,0,0.06)]"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        {tabs.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/feed"}
            data-testid={testid}
            className={({ isActive }) =>
              `relative flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-bold uppercase tracking-tight transition-colors ${
                isActive
                  ? "text-[hsl(var(--nh-red))]"
                  : "text-black/70 hover:text-black"
              }`
            }
          >
            <Icon className="w-5 h-5" strokeWidth={2.2} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </>
  );
}
